import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import api from "../../../core/api/config";
import jsPDF from "jspdf";
import "jspdf-autotable";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { calcularIdade } from "../../../shared/utils/calcularIdade";
import { capitalizarTexto } from "../../../shared/utils/formatador";

const TabHistoricoInteracoes = ({
  paciente,
  dadosCompletos,
  canalInteracaoSelecionado,
  setCanalInteracaoSelecionado,
  tipoInteracaoSelecionado,
  setTipoInteracaoSelecionado,
  dataInteracao,
  setDataInteracao,
  tipoRastreio,
  setTipoRastreio,
  observacao,
  resultado = "",
  setResultado,
  dataObito,
  setDataObito,
  tipoInteracaoId,
  setTipoInteracaoId,
  setObservacao,
  historico,
  setHistorico,
  onInteracaoSalva,
  onProcessarPaciente,
}) => {
  const tipoRastreamento = dadosCompletos?.tipoControle || "—";
  const dataNascimento = dadosCompletos?.dataNascimento || "Sem informação";

  // CORREÇÃO 1 & 2: Alterar condição para mostrar campos de procedimento/resultado
  // Agora mostra apenas para tipo 2 (Exame/Resultado de exame)
  const mostrarCamposProcedimentoResultado = tipoInteracaoId === 2;

  // CORREÇÃO 3: Não mostrar campos de procedimento e resultado para Informação de tratamento
  const mostrarCamposTratamento = tipoInteracaoId === 3;

  const mostrarCampoDataObito = tipoInteracaoId === 5;

  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState(null);
  const [mensagemErro, setMensagemErro] = useState("");
  const [erros, setErros] = useState({});
  const [selecionadas, setSelecionadas] = useState([]);
  const [usuarioLogadoId, setUsuarioLogadoId] = useState(null);

  // CORREÇÃO 1 & 2: Alterar nome da variável para ser mais genérica
  const [dataProcedimentoTratamento, setDataProcedimentoTratamento] =
    useState("");

  const [municipios, setMunicipios] = useState([]);
  const [municipioSelecionado, setMunicipioSelecionado] = useState(null);
  const [loadingSelecionadas, setLoadingSelecionadas] = useState(false);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);
  const [editandoInteracaoId, setEditandoInteracaoId] = useState(null);
  const [, setTouched] = useState({});
  const [filtros, setFiltros] = useState({
    tipoCanais: [],
    tipoInteracoes: [],
    tipoRastreios: [],
    resultadoExameHistcolo: [],
    resultadoExameSiscolo: [],
    resultadoExameMamografia: [],
    resultadoExameHistMama: [],
    tipoResultadoExame: [],
    colposcopiaHistcolo: [],
    resultadoUltrassonografia: [],
  });

  const MySwal = withReactContent(Swal);

  const swalConfig = {
    loading: {
      title: "Processando...",
      text: "Aguarde enquanto processamos sua solicitação.",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => MySwal.showLoading(),
    },
    success: {
      icon: "success",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
      timer: 5000,
    },
    error: {
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
      timer: 5000,
    },
    warning: {
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#67748e",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    },
  };

  const showLoading = (title = "Processando...", text = "Aguarde...") => {
    return MySwal.fire({
      ...swalConfig.loading,
      title,
      text,
    });
  };

  const showSuccess = (title, html) => {
    return MySwal.fire({
      ...swalConfig.success,
      title,
      html: html || undefined,
    });
  };

  const showError = (title, text) => {
    return MySwal.fire({
      ...swalConfig.error,
      title,
      text: text || undefined,
    });
  };

  const showWarning = (title, html) => {
    return MySwal.fire({
      ...swalConfig.warning,
      title,
      html: html || undefined,
    });
  };

  const showInfo = (title, text, timer = 4000) => {
    return MySwal.fire({
      icon: "info",
      title,
      text,
      showConfirmButton: false,
      timer,
    });
  };

  const formatarData = (dataISO) => {
    if (!dataISO) return "—";
    try {
      const partes = dataISO.split("T")[0].split("-");
      if (partes.length === 3) {
        const [ano, mes, dia] = partes;
        return `${dia}/${mes}/${ano}`;
      }
      return dataISO;
    } catch {
      return "—";
    }
  };

  const atualizarExames = () => {
    if (onInteracaoSalva) {
      onInteracaoSalva();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    api
      .get("/api/user/show", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setUsuarioLogadoId(res.data?.user?.id || null);
      })
      .catch((err) => {
        console.error("Erro ao buscar usuário logado:", err);
      });
  }, []);

  useEffect(() => {
    const fetchMunicipios = async () => {
      try {
        const res = await api.get("/api/cidade/list");
        const municipioArray = Array.isArray(res.data.data)
          ? res.data.data
          : Array.isArray(res.data.data?.data)
            ? res.data.data.data
            : [];
        const options = municipioArray.map((item) => ({
          value: item.codigo_municipio,
          label: item.municipio,
        }));
        setMunicipios(options);
      } catch (err) {
        console.error("Erro ao carregar municípios:", err);
      }
    };
    fetchMunicipios();
  }, []);

  useEffect(() => {
    const carregarTudo = async () => {
      if (!paciente?.id) return;
      setCarregandoHistorico(true);
      try {
        const { data: filtrosData } = await api.get(
          "/api/tracking/interacoes/filtros",
        );
        const mapOptions = (arr) =>
          Array.isArray(arr)
            ? arr.map((item) => ({
                value: item.id,
                label: item.descricao,
              }))
            : [];

        const novosFiltros = {
          tipoCanais: mapOptions(filtrosData.tipoCanais),
          tipoInteracoes: mapOptions(filtrosData.tipoInteracoes),
          tipoRastreios: mapOptions(filtrosData.tipoRastreios),
          resultadoExameHistcolo: mapOptions(
            filtrosData.resultadoExameHistcolo,
          ),
          resultadoExameSiscolo: mapOptions(filtrosData.resultadoExameSiscolo),
          resultadoExameMamografia: mapOptions(
            filtrosData.resultadoExameMamografia,
          ),
          resultadoExameHistMama: mapOptions(
            filtrosData.resultadoExameHistMama,
          ),
          tipoResultadoExame: mapOptions(filtrosData.tipoResultadoExame),
          colposcopiaHistcolo: mapOptions(filtrosData.colposcopiaHistcolo),
          resultadoUltrassonografia: mapOptions(
            filtrosData.resultadoUltrassonografia,
          ),
        };
        setFiltros(novosFiltros);

        const res = await api.get(
          `/api/tracking/interacoes/pessoa/${paciente.id}`,
        );
        const lista = res.data || [];

        const historicoFormatado = lista.map((item) => {
          const tipoRastreioLabel =
            novosFiltros.tipoRastreios.find(
              (r) => r.value === item.tipoRastreioId,
            )?.label || "—";

          const tipoInteracaoLabel =
            novosFiltros.tipoInteracoes.find(
              (i) => i.value === item.tipoInteracaoId,
            )?.label || "—";

          const canalLabel =
            novosFiltros.tipoCanais.find((c) => c.value === item.tipoCanalId)
              ?.label || "—";

          let procedimentoLabel = "—";
          if (item.tipoInteracaoId === 2) {
            procedimentoLabel =
              novosFiltros.tipoResultadoExame.find(
                (p) => p.value === item.tipoResultadoExameId,
              )?.label || "—";
          }

          const resultadoFormatado = {
            id: item.id,
            data: formatarData(item.data),
            tipoRastreio: tipoRastreioLabel,
            tipoInteracao: tipoInteracaoLabel,
            procedimento: procedimentoLabel,
            canal: canalLabel,
            observacao: item.observacao || "",
            tipoRastreioId: item.tipoRastreioId,
            tipoInteracaoId: item.tipoInteracaoId,
            tipoResultadoExameId: item.tipoResultadoExameId,
            tipoCanalId: item.tipoCanalId,
            dataObito: item.dataObito,
            dataProcedimento: item.dataProcedimento,
            resultado: item.resultado,
            resultadoExameId: item.resultadoExameId,
          };
          return resultadoFormatado;
        });
        setHistorico(historicoFormatado);
      } catch (err) {
        console.error("Erro ao carregar dados:", err);
      } finally {
        setCarregandoHistorico(false);
      }
    };
    carregarTudo();
  }, [paciente?.id]);

  useEffect(() => {
    if (paciente?.id) {
      setTipoInteracaoSelecionado(null);
      setDataInteracao("");
      setTipoRastreio(null);
      setObservacao("");
      setCanalInteracaoSelecionado(null);
      setResultado(null);
      setDataObito("");
      setTipoInteracaoId(null);
      setSelecionadas([]);
      setProcedimentoSelecionado(null);
      setErros({});
      setMensagemErro("");
      setDataProcedimentoTratamento("");
    }
  }, [paciente?.id]);

  const toggleSelecionarTodas = () => {
    if (selecionadas.length === historico.length) {
      setSelecionadas([]);
    } else {
      setSelecionadas([...historico]);
    }
  };

  const handleSalvar = async () => {
    const novosErros = {};

    if (!paciente?.id) novosErros.paciente = "Paciente não identificado.";
    if (!canalInteracaoSelecionado)
      novosErros.canal = "Selecione o canal de interação.";
    if (!dataInteracao) novosErros.data = "Informe a data do contato.";
    if (!tipoRastreio) novosErros.rastreio = "Selecione o tipo de rastreio.";
    if (!tipoInteracaoSelecionado)
      novosErros.interacao = "Selecione o tipo de interação.";

    // CORREÇÃO 4: Remover obrigatoriedade do campo observação para Exame/Resultado de Exame
    if (tipoInteracaoId !== 2 && !observacao.trim()) {
      novosErros.observacao = "A observação é obrigatória.";
    }

    // Validar campos específicos por tipo de interação
    if (tipoInteracaoId === 2) {
      // Exame/Resultado de Exame
      if (!procedimentoSelecionado)
        novosErros.procedimento = "Selecione o procedimento.";
      if (!resultado) novosErros.resultado = "Selecione o resultado.";
      if (!dataProcedimentoTratamento)
        novosErros.data_procedimento = "Informe a data da liberação do exame.";
    } else if (tipoInteracaoId === 3) {
      // Informação de Tratamento
      if (!dataProcedimentoTratamento)
        novosErros.data_procedimento =
          "Informe a data de início de tratamento.";
    }

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      setMensagemErro("Por favor, corrija os campos destacados.");
      return;
    }

    setErros({});
    setMensagemErro("");

    try {
      const payload = {
        id: editandoInteracaoId || null,
        pessoaId: paciente?.id || null,
        data: dataInteracao,
        tipoInteracaoId: tipoInteracaoSelecionado?.value || null,
        tipoResultadoExameId:
          tipoInteracaoId === 2 ? procedimentoSelecionado?.value || null : null,
        resultadoExameId:
          tipoInteracaoId === 2 ? resultado?.value || null : null,
        observacao: observacao || "",
        tipoRastreioId: tipoRastreio?.value || null,
        tipoCanalId: canalInteracaoSelecionado?.value || null,
        dataObito: mostrarCampoDataObito ? dataObito || null : null,
        dataProcedimento: [2, 3].includes(tipoInteracaoId)
          ? dataProcedimentoTratamento || null
          : null,
        resultado: tipoInteracaoId === 2 ? resultado?.label || null : null,
        usuario: usuarioLogadoId || null,
        cnesId: "3566226",
      };

      showLoading(
        editandoInteracaoId
          ? "Atualizando interação..."
          : "Salvando interação...",
        "Aguarde enquanto salvamos a interação.",
      );

      const res = await api.post("/api/tracking/interacoes", payload);
      const interacaoId = res.data?.id;

      if (editandoInteracaoId) {
        setHistorico((prev) =>
          prev.map((item) =>
            item.id === editandoInteracaoId
              ? {
                  ...item,
                  data: formatarData(dataInteracao),
                  tipoRastreio: tipoRastreio?.label || "—",
                  tipoInteracao: tipoInteracaoSelecionado?.label || "—",
                  procedimento:
                    tipoInteracaoId === 2
                      ? procedimentoSelecionado?.label || "—"
                      : "—",
                  observacao: observacao || "",
                  tipoRastreioId: tipoRastreio?.value || null,
                  tipoInteracaoId: tipoInteracaoSelecionado?.value || null,
                  tipoResultadoExameId: procedimentoSelecionado?.value || null,
                }
              : item,
          ),
        );
      } else {
        const novaInteracao = {
          id: interacaoId,
          data: formatarData(dataInteracao),
          tipoRastreio: tipoRastreio?.label || "—",
          tipoInteracao: tipoInteracaoSelecionado?.label || "—",
          procedimento:
            tipoInteracaoId === 2 ? procedimentoSelecionado?.label || "—" : "—",
          observacao: observacao || "",
          tipoRastreioId: tipoRastreio?.value || null,
          tipoInteracaoId: tipoInteracaoSelecionado?.value || null,
          tipoResultadoExameId: procedimentoSelecionado?.value || null,
        };
        setHistorico((prev) => [novaInteracao, ...prev]);
      }

      atualizarExames();
      limparFormulario();

      MySwal.update({
        title: "Processando paciente...",
        text: "Aguarde enquanto atualizamos os status do paciente.",
      });

      if (onProcessarPaciente) {
        await onProcessarPaciente();
      }

      MySwal.close();
      await showSuccess(
        editandoInteracaoId
          ? "Interação atualizada com sucesso!"
          : "Interação salva com sucesso!",
        <div className="text-center">
          <p style={{ fontSize: "16px", marginBottom: "10px" }}>
            Interação {editandoInteracaoId ? "atualizada" : "salva"} com sucesso
          </p>
          <p style={{ fontSize: "16px", color: "#6c757d" }}>
            Processamento automático desativado para teste
          </p>
        </div>,
      );
    } catch (err) {
      MySwal.close();
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Verifique os dados e tente novamente.";
      await showError("Erro ao salvar interação!", errorMessage);
    }
  };

  const showConfirmationAlert = (interacao) => {
    limparFormulario();
    showWarning(
      "Deseja realmente excluir esta interação?",
      <div className="text-left">
        <p style={{ fontSize: "16px", marginBottom: "10px" }}>
          Interação: {interacao.tipoInteracao}
        </p>
        <p style={{ fontSize: "16px", marginBottom: "8px" }}>
          Data do contato: {interacao.data}
        </p>
        <p style={{ fontSize: "16px" }} className="text-warning">
          <strong>Atenção:</strong> O paciente será processado automaticamente
          após a exclusão.
        </p>
      </div>,
    ).then(async (result) => {
      if (result.isConfirmed) {
        try {
          showLoading(
            "Excluindo interação...",
            "Aguarde enquanto processamos sua solicitação.",
          );

          const token = localStorage.getItem("token");
          await api.delete(`/api/tracking/interacoes/${interacao.id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          setHistorico((prev) => prev.filter((h) => h.id !== interacao.id));
          atualizarExames();

          MySwal.update({
            title: "Processando paciente...",
            text: "Atualizando os status após exclusão.",
          });

          if (onProcessarPaciente) {
            await onProcessarPaciente();
          }

          MySwal.close();
          await showSuccess(
            "Interação excluída com sucesso!",
            <div className="text-center">
              <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                Interação excluída com sucesso
              </p>
              <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                Paciente processado automaticamente
              </p>
              <p style={{ fontSize: "14px", color: "#6c757d" }}>
                Status atualizados
              </p>
            </div>,
          );
        } catch (err) {
          console.error("Erro ao excluir interação:", err);
          MySwal.close();
          await showError("Erro ao excluir!", "Tente novamente mais tarde.");
        }
      }
    });
  };

  const editarInteracao = async (interacao) => {
    try {
      limparFormulario();
      const token = localStorage.getItem("token");
      const { data } = await api.get(
        `/api/tracking/interacoes/buscar/${interacao.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setTipoInteracaoId(data.tipoInteracaoId);
      setDataInteracao(data.data || "");
      setObservacao(data.observacao || "");
      setDataObito(data.dataObito || "");
      setDataProcedimentoTratamento(data.dataProcedimento || data.data || "");

      const tipoInteracaoEncontrado = filtros.tipoInteracoes.find(
        (t) => t.value === data.tipoInteracaoId,
      );
      setTipoInteracaoSelecionado(tipoInteracaoEncontrado || null);

      const tipoRastreioEncontrado = filtros.tipoRastreios.find(
        (r) => r.value === data.tipoRastreioId,
      );
      setTipoRastreio(tipoRastreioEncontrado || null);

      const canalEncontrado = filtros.tipoCanais.find(
        (c) => c.value === data.tipoCanalId,
      );
      setCanalInteracaoSelecionado(canalEncontrado || null);

      let procSelecionado = null;

      if (data.tipoInteracaoId === 2) {
        if (data.resultado && data.resultado.includes("Bi-RADS")) {
          procSelecionado = filtros.tipoResultadoExame.find(
            (p) => p.label === "Mamografia",
          );
        } else if (data.tipoResultadoExameId) {
          procSelecionado = filtros.tipoResultadoExame.find(
            (p) => p.value === data.tipoResultadoExameId,
          );
        }

        if (!procSelecionado) {
          if (data.tipoRastreioId === 1) {
            procSelecionado = filtros.tipoResultadoExame.find(
              (p) => p.label === "Citopatológico de Colo",
            );
          } else if (data.tipoRastreioId === 2) {
            procSelecionado = filtros.tipoResultadoExame.find(
              (p) => p.label === "Mamografia",
            );
          }
        }
      }

      setProcedimentoSelecionado(procSelecionado);

      let resultadoSelecionado = null;
      if (data.resultado && data.tipoInteracaoId === 2) {
        if (procSelecionado) {
          const resultadosDoProcedimento =
            mapResultadosPorProcedimento[procSelecionado.label] || [];
          resultadoSelecionado = resultadosDoProcedimento.find((r) => {
            const match =
              r.label.toLowerCase().includes(data.resultado.toLowerCase()) ||
              data.resultado.toLowerCase().includes(r.label.toLowerCase());
            return match;
          });
        }

        if (!resultadoSelecionado && data.resultado.includes("Bi-RADS")) {
          const resultadosMamografia =
            mapResultadosPorProcedimento["Mamografia"] || [];
          resultadoSelecionado = resultadosMamografia.find(
            (r) =>
              r.label.toLowerCase().includes("inconclusivo") ||
              r.label.toLowerCase().includes("bi-rads 0"),
          );
          if (!resultadoSelecionado && resultadosMamografia.length > 0) {
            resultadoSelecionado = resultadosMamografia[0];
          }
        }

        if (!resultadoSelecionado) {
          resultadoSelecionado = {
            value: "custom",
            label: data.resultado,
          };
        }
      }

      setResultado(resultadoSelecionado);
      setEditandoInteracaoId(data.id);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      showInfo(
        "Editando interação",
        "Preencha os campos e clique em 'Salvar Interação' para atualizar.",
      );
    } catch (err) {
      console.error("Erro ao editar interação:", err);
      showError(
        "Erro ao carregar dados da interação!",
        "Não foi possível buscar os dados para edição.",
      );
    }
  };

  const limparFormulario = () => {
    setTipoInteracaoSelecionado(null);
    setDataInteracao("");
    setTipoRastreio(null);
    setObservacao("");
    setCanalInteracaoSelecionado(null);
    setProcedimentoSelecionado(null);
    setResultado(null);
    setDataObito("");
    setTipoInteracaoId(null);
    setEditandoInteracaoId(null);
    setMensagemErro("");
    setDataProcedimentoTratamento("");
    setMunicipioSelecionado(null);
    setErros({});
    setTouched({});
  };

  const handleLimpar = () => {
    setCanalInteracaoSelecionado(null);
    setDataInteracao("");
    setTipoRastreio(null);
    setTipoInteracaoSelecionado(null);
    setTipoInteracaoId(null);
    setProcedimentoSelecionado(null);
    setResultado(null);
    setDataProcedimentoTratamento("");
    setMunicipioSelecionado(null);
    setDataObito("");
    setObservacao("");
    setErros({});
    setMensagemErro("");
    limparFormulario();
  };

  const mapResultadosPorProcedimento = {
    "Histopatológico de Colo": filtros.resultadoExameHistcolo,
    "Histopatológico de Mama": filtros.resultadoExameHistMama,
    "Citopatológico de Colo": filtros.resultadoExameSiscolo,
    Mamografia: filtros.resultadoExameMamografia,
    Colposcopia: filtros.colposcopiaHistcolo,
    "Ultrassonografia de mama": filtros.resultadoUltrassonografia,
  };

  const procedimentos = filtros.tipoResultadoExame;

  const procedimentosFiltrados = React.useMemo(() => {
    if (!tipoRastreio?.label) return [];
    const label = tipoRastreio.label.toLowerCase();

    if (label.includes("colo") && !label.includes("mama")) {
      return procedimentos.filter((p) => {
        const pl = p.label.toLowerCase();
        return pl.includes("colo") || pl.includes("colposcopia");
      });
    }

    if (label.includes("mama") && !label.includes("colo")) {
      return procedimentos.filter((p) => {
        const pl = p.label.toLowerCase();
        return (
          pl.includes("mama") ||
          pl.includes("ultrassonografia") ||
          pl.includes("mamografia")
        );
      });
    }

    if (label.includes("colo") && label.includes("mama")) {
      return procedimentos;
    }

    return [];
  }, [tipoRastreio, procedimentos]);

  // const usuarioLogadoNome = localStorage.getItem("usuarioNome") || "—";

  const gerarPDFInteracao = async (interacao) => {
    try {
      limparFormulario();
      const token = localStorage.getItem("token");
      const response = await api.get(
        `/api/tracking/interacoes/buscar/${interacao.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = Array.isArray(response.data)
        ? response.data[0]
        : response.data;
      if (!data) return console.error("Interação não encontrada");

      const canal =
        filtros.tipoCanais.find((c) => c.value === data.tipoCanalId)?.label ||
        "—";

      const tipoRastreioLabel =
        filtros.tipoRastreios.find((r) => r.value === data.tipoRastreioId)
          ?.label || "—";

      const tipoInteracaoLabel =
        filtros.tipoInteracoes.find((t) => t.value === data.tipoInteracaoId)
          ?.label || "—";

      const procedimentoLabel =
        filtros.tipoResultadoExame.find(
          (p) => p.value === data.tipoResultadoExameId,
        )?.label || "—";

      const resultadoLabel =
        Object.values(mapResultadosPorProcedimento)
          .flat()
          .find((r) => r.value === data.resultado)?.label ||
        data.resultado ||
        "—";

      const doc = new jsPDF();
      const logo = new Image();
      logo.src = "assets/img/logo.png";

      logo.onload = () => {
        const maxWidth = 30;
        const ratio = logo.height / logo.width;
        const displayHeight = maxWidth * ratio;

        doc.addImage(logo, "PNG", 10, 10, maxWidth, displayHeight);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text(
          "RELATÓRIO DE INTERAÇÃO",
          doc.internal.pageSize.width / 2,
          20,
          { align: "center" },
        );

        const separadorY = Math.max(25, 10 + displayHeight + 5);
        doc.line(10, separadorY, doc.internal.pageSize.width - 10, separadorY);

        let y = separadorY + 10;
        const campos = [
          ["Código", data.id || "—"],
          ["Paciente", paciente?.nome || "—"],
          ["Canal de Interação", canal],
          ["Data do Contato", formatarData(data.data) || "—"],
          ["Tipo de Rastreio", tipoRastreioLabel],
          ["Tipo de Interação", tipoInteracaoLabel],
          ["Data de Óbito", formatarData(data.dataObito) || "—"],
          ["Data do Procedimento", formatarData(data.dataProcedimento) || "—"],
          ["Procedimento", procedimentoLabel],
          ["Resultado", resultadoLabel],
          ["Observação", data.observacao || "—"],
        ];

        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        campos.forEach(([label, valor]) => {
          doc.text(`${label}: ${valor}`, 10, y);
          y += 8;
        });

        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(9);
        doc.setTextColor(100);
        doc.text(
          `Gerado em: ${new Date().toLocaleString("pt-BR")} | Usuário: ${
            usuarioLogadoId || "—"
          }`,
          doc.internal.pageSize.width - 10,
          pageHeight - 10,
          { align: "right" },
        );

        window.open(doc.output("bloburl"), "_blank");
      };
    } catch (err) {
      console.error("Erro ao gerar PDF:", err);
    }
  };

  const gerarPDFSelecionadas = async () => {
    try {
      limparFormulario();
      setLoadingSelecionadas(true);
      const token = localStorage.getItem("token");
      const doc = new jsPDF();
      const logo = new Image();
      logo.src = "assets/img/logo.png";

      logo.onload = async () => {
        const maxWidth = 30;
        const ratio = logo.height / logo.width;
        const displayHeight = maxWidth * ratio;

        for (let i = 0; i < selecionadas.length; i++) {
          const interacao = selecionadas[i];
          const response = await api.get(
            `/api/tracking/interacoes/buscar/${interacao.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          if (!data) continue;

          const canal =
            filtros.tipoCanais.find((c) => c.value === data.tipoCanalId)
              ?.label || "—";

          const tipoRastreioLabel =
            filtros.tipoRastreios.find((r) => r.value === data.tipoRastreioId)
              ?.label || "—";

          const tipoInteracaoLabel =
            filtros.tipoInteracoes.find((t) => t.value === data.tipoInteracaoId)
              ?.label || "—";

          const procedimentoLabel =
            filtros.tipoResultadoExame.find(
              (p) => p.value === data.tipoResultadoExameId,
            )?.label || "—";

          const resultadoLabel =
            Object.values(mapResultadosPorProcedimento)
              .flat()
              .find((r) => r.value === data.resultado)?.label ||
            data.resultado ||
            "—";

          if (i > 0) doc.addPage();

          doc.setTextColor(0); // preto
          doc.setDrawColor(0);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(12);

          doc.addImage(logo, "PNG", 10, 10, maxWidth, displayHeight);
          doc.setFontSize(16);
          doc.setFont("helvetica", "bold");
          doc.text(
            "RELATÓRIO DE INTERAÇÃO",
            doc.internal.pageSize.width / 2,
            20,
            { align: "center" },
          );

          const separadorY = Math.max(25, 10 + displayHeight + 5);
          doc.setDrawColor(0);
          doc.setLineWidth(0.5);
          doc.line(
            10,
            separadorY,
            doc.internal.pageSize.width - 10,
            separadorY,
          );

          let y = separadorY + 10;
          doc.setFont("helvetica", "normal");
          doc.setFontSize(12);

          const campos = [
            ["Código", data.id || "—"],
            ["Paciente", paciente?.nome || "—"],
            ["Canal de Interação", canal],
            ["Data do Contato", formatarData(data.data) || "—"],
            ["Tipo de Rastreio", tipoRastreioLabel],
            ["Tipo de Interação", tipoInteracaoLabel],
            ["Data de Óbito", formatarData(data.dataObito) || "—"],
            [
              "Data do Procedimento",
              formatarData(data.dataProcedimento) || "—",
            ],
            ["Procedimento", procedimentoLabel],
            ["Resultado", resultadoLabel],
            ["Observação", data.observacao || "—"],
          ];

          campos.forEach(([label, valor]) => {
            doc.text(`${label}: ${valor}`, 10, y);
            y += 8;
          });

          const pageHeight = doc.internal.pageSize.height;
          doc.setFontSize(9);
          doc.setTextColor(100);
          doc.text(
            `Gerado em: ${new Date().toLocaleString(
              "pt-BR",
            )} | Usuário: ${usuarioLogadoId}`,
            doc.internal.pageSize.width - 10,
            pageHeight - 10,
            { align: "right" },
          );

          doc.setTextColor(100);
          doc.text(
            `Página ${i + 1} de ${selecionadas.length}`,
            10,
            pageHeight - 10,
          );
        }

        window.open(doc.output("bloburl"), "_blank");
        setLoadingSelecionadas(false);
      };
    } catch (err) {
      console.error("Erro ao gerar PDF das interações selecionadas:", err);
      setLoadingSelecionadas(false);
    }
  };

  // CORREÇÃO 1 & 2: Função para determinar o label do campo de data
  const getDataFieldLabel = () => {
    if (tipoInteracaoId === 2) {
      return "Data da Liberação do Exame";
    } else if (tipoInteracaoId === 3) {
      return "Data de Início do Tratamento";
    }
    return "Data do Procedimento";
  };

  // CORREÇÃO 5: Função para determinar o label do campo observação
  const getObservacaoLabel = () => {
    return "Descrição da Interação";
  };

  return (
    <div className="interacoes">
      <div className="informacoes-pessoais p-3 d-grid gap-4">
        <div className="row g-3">
          <div className="col-12 col-md-3">
            <div className="text-muted small mb-1">Paciente</div>
            <div className="fw-semibold text-dark">
              {capitalizarTexto(paciente.nome) || "—"}
            </div>
          </div>

          <div className="col-6 col-md-2">
            <div className="text-muted small mb-1">ID</div>
            <div className="fw-semibold text-dark">{paciente.id || "—"}</div>
          </div>

          <div className="col-6 col-md-2">
            <div className="text-muted small mb-1">Data de nascimento</div>
            <div className="fw-semibold text-dark">
              {formatarData(dataNascimento)}
            </div>
          </div>

          <div className="col-6 col-md-2">
            <div className="text-muted small mb-1">Idade</div>
            <div className="fw-semibold text-dark">
              {calcularIdade(dataNascimento)}
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="text-muted small mb-1">Tipo de Rastreamento</div>
            <div className="fw-semibold text-dark">{tipoRastreamento}</div>
          </div>
        </div>
      </div>

      <div className="nova-interacao p-3 d-grid gap-4">
        <div className="row g-3">
          <form>
              <div className="row mb-3">
                <div className="col-md-12">
                  <h5>Nova Interação</h5>
                  <hr />
                </div>
                <div className="col-md-12 mb-3">
                  {mensagemErro && (
                    <div className="alert alert-danger" role="alert">
                      {mensagemErro}
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <label>Canal de Interação:*</label>
                  <Select
                    options={filtros.tipoCanais}
                    value={canalInteracaoSelecionado}
                    onChange={(value) => {
                      setCanalInteracaoSelecionado(value);
                      setErros((prev) => ({ ...prev, canal: "" }));
                    }}
                    placeholder="Selecione o canal ..."
                    classNamePrefix="react-select"
                    className={`react-select-container ${
                      erros.canal ? "is-invalid" : ""
                    } ${
                      !erros.canal && canalInteracaoSelecionado
                        ? "is-valid"
                        : ""
                    }`}
                  />
                  {erros.canal && (
                    <div className="invalid-feedback d-block">
                      {erros.canal}
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <label>Data do Contato:*</label>
                  <input
                    type="date"
                    className={`form-control ${erros.data ? "is-invalid" : ""}`}
                    value={dataInteracao}
                    onChange={(e) => {
                      setDataInteracao(e.target.value);
                      setErros((prev) => ({ ...prev, data: "" }));
                    }}
                  />
                  {erros.data && (
                    <div className="invalid-feedback">{erros.data}</div>
                  )}
                </div>

                <div className="col-md-4">
                  <label>Tipo de Rastreio:*</label>
                  <Select
                    options={filtros.tipoRastreios}
                    value={tipoRastreio}
                    onChange={(value) => {
                      setTipoRastreio(value);
                      setErros((prev) => ({ ...prev, rastreio: "" }));
                    }}
                    placeholder="Selecione o tipo de rastreio ..."
                    classNamePrefix="react-select"
                    className={`react-select-container ${
                      erros.rastreio ? "is-invalid" : ""
                    } ${!erros.rastreio && tipoRastreio ? "is-valid" : ""}`}
                  />
                  {erros.rastreio && (
                    <div className="invalid-feedback d-block">
                      {erros.rastreio}
                    </div>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <label>Tipo de Interação:*</label>
                  <Select
                    options={filtros.tipoInteracoes}
                    value={tipoInteracaoSelecionado}
                    onChange={(value) => {
                      setTipoInteracaoSelecionado(value);
                      setTipoInteracaoId(value?.value || null);
                      setErros((prev) => ({ ...prev, interacao: "" }));
                    }}
                    placeholder="Selecione o tipo de interação ..."
                    classNamePrefix="react-select"
                    className={`react-select-container ${
                      erros.interacao ? "is-invalid" : ""
                    } ${
                      !erros.interacao && tipoInteracaoSelecionado
                        ? "is-valid"
                        : ""
                    }`}
                  />
                  {erros.interacao && (
                    <div className="invalid-feedback d-block">
                      {erros.interacao}
                    </div>
                  )}
                </div>

                {/* CORREÇÃO 1 & 3: Mostrar campos apenas para Exame/Resultado de exame (tipo 2) */}
                {mostrarCamposProcedimentoResultado && (
                  <>
                    <div className="col-md-4 mb-3">
                      <label>Procedimento:*</label>
                      <Select
                        options={procedimentosFiltrados}
                        value={procedimentoSelecionado}
                        onChange={(value) => {
                          setProcedimentoSelecionado(value);
                          setErros((prev) => ({
                            ...prev,
                            procedimento: "",
                            resultado: "",
                          }));
                        }}
                        placeholder="Selecione o procedimento..."
                        isClearable
                        isDisabled={!!editandoInteracaoId || !tipoRastreio}
                        classNamePrefix="react-select"
                        className={`react-select-container ${
                          erros.procedimento ? "is-invalid" : ""
                        }`}
                      />
                      {erros.procedimento && (
                        <div className="invalid-feedback d-block">
                          {erros.procedimento}
                        </div>
                      )}
                      {!tipoRastreio && (
                        <small className="form-text text-muted">
                          Selecione primeiro o tipo de rastreio
                        </small>
                      )}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Resultado:*</label>
                      <Select
                        options={
                          mapResultadosPorProcedimento[
                            procedimentoSelecionado?.label
                          ] || []
                        }
                        value={resultado}
                        onChange={(option) => {
                          setResultado(option);
                          setErros((prev) => ({ ...prev, resultado: "" }));
                        }}
                        placeholder="Selecione o resultado..."
                        isClearable
                        isDisabled={!procedimentoSelecionado}
                        classNamePrefix="react-select"
                        className={`react-select-container ${
                          erros.resultado ? "is-invalid" : ""
                        }`}
                      />
                      {erros.resultado && (
                        <div className="invalid-feedback d-block">
                          {erros.resultado}
                        </div>
                      )}
                      {!procedimentoSelecionado && (
                        <small className="form-text text-muted">
                          Selecione primeiro o procedimento
                        </small>
                      )}
                    </div>

                    {/* CORREÇÃO 1: Campo para Data da Liberação do Exame */}
                    <div className="col-md-4 mb-3">
                      <label>{getDataFieldLabel()}:*</label>
                      <input
                        type="date"
                        className={`form-control ${
                          erros.data_procedimento ? "is-invalid" : ""
                        }`}
                        value={dataProcedimentoTratamento || ""}
                        onChange={(e) => {
                          setDataProcedimentoTratamento(e.target.value);
                          setErros((prev) => ({
                            ...prev,
                            data_procedimento: "",
                          }));
                        }}
                      />
                      {erros.data_procedimento && (
                        <div className="invalid-feedback">
                          {erros.data_procedimento}
                        </div>
                      )}
                    </div>
                  </>
                )}

                {/* CORREÇÃO 2 & 3: Mostrar apenas campo de data para Informação de Tratamento */}
                {mostrarCamposTratamento && (
                  <div className="col-md-4 mb-3">
                    <label>{getDataFieldLabel()}:*</label>
                    <input
                      type="date"
                      className={`form-control ${
                        erros.data_procedimento ? "is-invalid" : ""
                      }`}
                      value={dataProcedimentoTratamento || ""}
                      onChange={(e) => {
                        setDataProcedimentoTratamento(e.target.value);
                        setErros((prev) => ({
                          ...prev,
                          data_procedimento: "",
                        }));
                      }}
                    />
                    {erros.data_procedimento && (
                      <div className="invalid-feedback">
                        {erros.data_procedimento}
                      </div>
                    )}
                  </div>
                )}

                {tipoInteracaoId === 4 && (
                  <div className="col-md-4 mb-3">
                    <label>Novo Município/Estado:*</label>
                    <Select
                      options={municipios}
                      value={municipioSelecionado}
                      placeholder="Selecione o município ..."
                      isClearable
                      onChange={(option) => {
                        setMunicipioSelecionado(option);
                        setErros((prev) => ({ ...prev, municipio: "" }));
                      }}
                      classNamePrefix="react-select"
                      className={`react-select-container ${
                        erros.municipio ? "is-invalid" : ""
                      } ${
                        !erros.municipio && municipioSelecionado
                          ? "is-valid"
                          : ""
                      }`}
                    />
                    {erros.municipio && (
                      <div className="invalid-feedback d-block">
                        {erros.municipio}
                      </div>
                    )}
                  </div>
                )}

                {mostrarCampoDataObito && (
                  <div className="col-md-4 mb-3">
                    <label>Data de Óbito:</label>
                    <input
                      type="date"
                      className={`form-control ${
                        erros.dataObito ? "is-invalid" : ""
                      }`}
                      value={dataObito}
                      onChange={(e) => {
                        setDataObito(e.target.value);
                        setErros((prev) => ({ ...prev, dataObito: "" }));
                      }}
                    />
                    {erros.dataObito && (
                      <div className="invalid-feedback">{erros.dataObito}</div>
                    )}
                  </div>
                )}

                <div className="col-md-12">
                  <label>
                    {getObservacaoLabel()}:
                    {tipoInteracaoId !== 2 && (
                      <span className="text-dark">*</span>
                    )}
                  </label>
                  <textarea
                    className={`form-control ${
                      erros.observacao ? "is-invalid" : ""
                    }`}
                    rows="3"
                    value={observacao}
                    onChange={(e) => {
                      setObservacao(e.target.value);
                      if (erros.observacao) {
                        setErros((prev) => ({ ...prev, observacao: "" }));
                      }
                    }}
                  />
                  {erros.observacao && (
                    <div className="invalid-feedback">{erros.observacao}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12 d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  onClick={handleLimpar}
                >
                  <i className="feather-x me-2"></i>
                  Limpar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSalvar}
                >
                  <i className="feather-save me-2"></i>
                  {editandoInteracaoId
                    ? "Atualizar Interação"
                    : "Salvar Interação"}
                </button>
              </div>
          </form>
        </div>
      </div>

      <div className="historico p-3 d-grid gap-4">
        <div>
          <h5 className="mb-3">Histórico</h5>
          <hr />
          <div className="table-responsive mt-3">
            <table className="table table-sm table-bordered table-hover align-middle">
              <thead className="thead-light">
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={toggleSelecionarTodas}
                      checked={
                        selecionadas.length === historico.length &&
                        historico.length > 0
                      }
                    />
                  </th>
                  <th>Data do Contato</th>
                  <th>Tipo de Rastreio</th>
                  <th>Tipo de Interação</th>
                  <th>Procedimento</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {carregandoHistorico ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                    </td>
                  </tr>
                ) : historico.length > 0 ? (
                  historico.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selecionadas.some((s) => s.id === item.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelecionadas([...selecionadas, item]);
                              } else {
                                setSelecionadas(
                                  selecionadas.filter((s) => s.id !== item.id),
                                );
                              }
                            }}
                          />
                        </td>
                        <td>{item.data}</td>
                        <td>{item.tipoRastreio}</td>
                        <td>{item.tipoInteracao}</td>
                        <td>
                          {item.tipoInteracaoId === 2 ? (
                            item.procedimento || "—"
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-warning me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              editarInteracao(item);
                            }}
                            title="Editar interação"
                          >
                            <i data-feather="edit" className="feather-edit"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              showConfirmationAlert(item);
                            }}
                            title="Excluir interação"
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            ></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              gerarPDFInteracao(item);
                            }}
                            title="Gerar PDF da interação"
                          >
                            <i
                              data-feather="file-text"
                              className="feather-file-text"
                            ></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      Nenhuma interação encontrada
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="mt-2">
              <small className="text-muted">
                * Procedimento aplica-se apenas ao tipo de interação 2
                (Exame/resultado de exame)
              </small>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-primary"
                onClick={gerarPDFSelecionadas}
                disabled={loadingSelecionadas || selecionadas.length === 0}
              >
                <i
                  data-feather="file-text"
                  className="feather-file-text m-2"
                ></i>
                {loadingSelecionadas
                  ? "Gerando PDF..."
                  : `Gerar PDF Selecionadas (${selecionadas.length})`}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TabHistoricoInteracoes.propTypes = {
  dadosCompletos: PropTypes.object,
  paciente: PropTypes.object.isRequired,
  tiposInteracao: PropTypes.array,
  tipoInteracaoSelecionado: PropTypes.object,
  setTipoInteracaoSelecionado: PropTypes.func.isRequired,
  dataInteracao: PropTypes.string.isRequired,
  setDataInteracao: PropTypes.func.isRequired,
  tipoRastreio: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  setTipoRastreio: PropTypes.func.isRequired,
  tiposRastreio: PropTypes.array,
  observacao: PropTypes.string.isRequired,
  resultado: PropTypes.string,
  setResultado: PropTypes.func.isRequired,
  dataObito: PropTypes.string.isRequired,
  setDataObito: PropTypes.func.isRequired,
  tipoInteracaoId: PropTypes.number,
  setTipoInteracaoId: PropTypes.func.isRequired,
  canalInteracaoSelecionado: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  setCanalInteracaoSelecionado: PropTypes.func.isRequired,
  setObservacao: PropTypes.func.isRequired,
  procedimento: PropTypes.string,
  historico: PropTypes.array.isRequired,
  setHistorico: PropTypes.func.isRequired,
  onInteracaoSalva: PropTypes.func,
  onProcessarPaciente: PropTypes.func,
};

export default TabHistoricoInteracoes;
